import { setStore, getStore } from '@/utils/store'
import {  LANG } from '@/configs/global'
// import { useI18n } from "vue-i18n";

const app = {
    state: {
        appId: 1040,    // 游戏id
        gameName: getStore({ name: 'gameName' }) || "",
        channel: 28 ,   // 渠道 getStore({ name: 'channel' }) || CHANNEL.GOOGLE_PLAY
        lang: getStore({ name: 'lang' }) || "zh_CN",
        os:"html5",
        deviceId: getStore({ name: 'deviceId' }) || '',
        uploadLog: getStore({ name: 'uploadLog' }) || '',  //日志服务
        sandbox:getStore({ name: 'sandbox' }) || 0,   //沙盒模式
        test: getStore({ name: 'test' }) || 0  ,       //是否测试模式 0-等于正常模式 1-登录测试模式
        gameId:  getStore({ name: 'gameId' }) || 1040,
        gameLoginType: getStore({ name: 'gameLoginType' }) || '',
        version: getStore({ name: 'version' }) || '',
        records: getStore({name: 'records'}) || [],
        miniGame: getStore({name: 'miniGame'}) || null,
    },

    mutations: {
        setGameId(state, value) {
            state.gameId = value
            setStore({ name: 'gameId', content: state.gameId })
        },
        setGameName(state, value) {
            state.gameName = value
            setStore({ name: 'gameName', content: state.gameName })
        },
        setChannel(state, value) {
            state.channel = value
            setStore({ name: 'channel', content: state.channel })
        },
        setUploadLog(state,value){
            state.uploadLog = value
            setStore({ name: 'uploadLog', content: state.uploadLog })
        },
        setLang(state, value) {
            if (!LANG[value]) {
                value = LANG.EN_US
            }
            state.lang = value
            setStore({ name: 'lang', content: state.lang })
            if (state.lang == 'ar_SA') {
                document.querySelector('html').setAttribute('lang', "ar");
                document.querySelector('html').setAttribute('dir', 'rtl');
            } else {
                document.querySelector('html').removeAttribute('dir')
            }
        },
        setOfficial(state, value) {
            state.official = value
            setStore({ name: 'official', content: state.official })
        },
        setDeviceId(state, value) {
            state.deviceId = value
            setStore({ name: 'deviceId', content: state.deviceId })
        },
        setSandbox(state,value){
            state.sandbox = value;
            setStore({ name: 'sandbox', content:  state.sandbox })
        },
        setTest(state,value){
            state.test = value;
            setStore({ name: 'test', content:  state.test })
        },
        setGameLoginType(state,value){
            state.gameLoginType = value;
            setStore({
                name: 'gameLoginType' , content: state.gameLoginType
            })
        },
        setVersion(state,value){
            state.version = value;
            setStore({
                name: 'version' , content: state.version
            })
        },
        setRecords(state,value){
           if(state.records && state.records.length != 0){
                var make = true;
                for(var i = 0;i <= state.records.length; i++){
                    var recor = state.records[i];
                    if(recor){
                        if(recor.playletId == value.playletId && recor.episId == value.episId){ //短剧ID跟集数ID
                            state.records[i] = value;  //刷新时长
                            make = false;
                        }
                    }
                }
                //表示没有找到
                if(make){
                    state.records.push(value)
                }
            }else{
                state.records.push(value)
            }
            setStore({
                name: 'records', content: state.records 
            })
        },
        setMiniGame(state,value){
            state.miniGame = value;
            setStore({
                name: 'miniGame',content: state.miniGame
            })
        }
    },

    actions: {
        initGame (state, info) {
            state.commit('setGameId', parseInt(info.gameId))
            state.commit('setGameName', info.gameName)
            state.commit('setChannel', parseInt(info.channel))
            if (info.lang) {
                state.commit('setLang', info.lang)
            }
        },
        gameLoginType(state,info){
            if(info && info.gameLoginType){
                state.commit('setGameLoginType', info.gameLoginType);
                return;
            }
            state.commit('setGameLoginType', '');
        }
    }
}

export default app;